import { Injectable } from '@angular/core';
import { PersistedReportRequest } from '@shared/services/report-stream/report-stream.models';

@Injectable({
  providedIn: 'root',
})
export class ReportGenerationStorageService {
  private static readonly STORAGE_KEY = 'sep-monitoring:report-generation:in-flight';
  private static readonly TTL_MS = 35 * 60 * 1000;

  save(request: PersistedReportRequest): void {
    sessionStorage.setItem(ReportGenerationStorageService.STORAGE_KEY, JSON.stringify(request));
  }

  read(): PersistedReportRequest | null {
    const raw = sessionStorage.getItem(ReportGenerationStorageService.STORAGE_KEY);

    if (!raw) {
      return null;
    }

    try {
      const parsed = JSON.parse(raw) as PersistedReportRequest;

      if (!this.hasRequiredFields(parsed) || this.isExpired(parsed)) {
        this.clear();
        return null;
      }

      return parsed;
    } catch {
      this.clear();
      return null;
    }
  }

  clear(): void {
    sessionStorage.removeItem(ReportGenerationStorageService.STORAGE_KEY);
  }

  private hasRequiredFields(request: PersistedReportRequest): boolean {
    if (typeof request?.createdAt !== 'number') {
      return false;
    }

    if (!request.geaPUID) {
      return false;
    }

    if (!request.start) {
      return false;
    }

    if (!request.stop) {
      return false;
    }

    return Boolean(request.timezone);
  }

  private isExpired(request: PersistedReportRequest): boolean {
    return Date.now() - request.createdAt > ReportGenerationStorageService.TTL_MS;
  }
}
